// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".df-telephone__input[data-v-5cbdafc6]{width:100%}.df-telephone[data-v-5cbdafc6]{margin-top:15px}", ""]);
// Exports
module.exports = exports;
